import React from 'react'
import GetStartedButton from './get-started'
import Login from './login'

type GetStartedLoginButtonProps = {
    isLogin?: boolean
}

const GetStartedLoginButton = ({ isLogin }: GetStartedLoginButtonProps) => {
    return isLogin ? <Login /> : <GetStartedButton />
}

export default GetStartedLoginButton
